<template>
  <div>
    <CRow>
      <CCol col="12 col-sm-8">
        <CCard>
          <CCardHeader>
            لیست ویژگی اضافی
          </CCardHeader>
          <CCardBody>

            <CDataTableFixed
                :items="items"
                :fields="fields"

                :items-per-page="20"
                hover
                sorter
                pagination
            >
              <template #row="{item}">
                <td>
                  <p class="text-muted">{{ item.row_id + 1 }}</p>
                </td>
              </template>
              <template #type="{item}">
                <td>
                  <p class="text-muted">{{
type_list.filter(x=>x.value==item.type)[0].label
                    }}</p>
                </td>
              </template>


              <template #operation="{item}">
                <td class="py-2">
                  <CButton
                      color="primary"
                      variant="outline"
                      square
                      size="sm"
                      v-if="type_list.filter(x=>x.value==item.type)[0].has_multiple_value"
                      @click="goSubCategories(item)"
                  >مقادیر ویژگی
                  </CButton>
                  <CButton
                      color="warning"
                      variant="outline"
                      square
                      size="sm"
                      @click="editDetails(item)"
                  ><CIcon name="cil-pencil" size="sm"/>
                  </CButton>
                  <CButton
                      color="danger"
                      variant="outline"
                      square
                      size="sm"
                      @click="delete_dialog(item)"
                  ><CIcon name="cil-trash" size="sm"/>
                  </CButton>
                </td>
              </template>


            </CDataTableFixed>
          </CCardBody>

        </CCard>
      </CCol>
      <CCol col="12 col-sm-4">
        <CCard>
          <CCardHeader>
            <strong>ثبت ویژگی جدید</strong>

          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol col="12">
                <CInput
                    v-model="name"
class="required"
                    label="نام"
                />
              </CCol>
              <CCol col="12">
                <CSelect
                    :value.sync="type"
class="required"
                    :options="type_list"
                    label="نوع"
                />
              </CCol>
              <CCol col="12">
                <CInput
                    v-model="summary"
class="required"
                    label="متن نمایشی"
                />
              </CCol>
              <CCol col="12">
                <CInput v-if="!type_list.filter(x=>x.value==type)[0].has_multiple_value"
                    v-model="price"
class="required"
                    label="مبلغ اضافی"
                />
              </CCol>
            </CRow>


          </CCardBody>
          <CCardFooter>
            <CButton
                @click="login()"
                type="submit" ref="submit_form" size="sm" color="primary">
              <CIcon name="cil-check-circle"/>
             {{status_form==0 ? 'ثبت ویژگی' : 'ویرایش ویژگی' }}
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>

    </CRow>



  </div>

</template>

<script>
import axios from "axios";
import {bus} from "../../../main";


export default {
  name: 'Login',
  data() {
    return {
      confirm_delete_name:new Date().getTime()+"_"+this.$vnode.tag,

      name: '',
      type: 1,
      type_list:[
          {label:'چک باکس',value:1,has_multiple_value:false},
          {label:'منو کشویی',value:2,has_multiple_value:true},
          {label:'دکمه رادیویی',value:3,has_multiple_value:true}
      ],

      summary:'',
      price:'0',
      items: [],
      fields: [
        {key: 'row',label: '#', _style: 'width:10%'},
        {key: 'title',label: 'نام', _style: 'width:10%'},
        {key: 'type',label: 'نوع', _style: 'width:10%'},
        {key: 'operation', _style: 'width:40%;'},
      ],
      status_form: 0
    }
  }, mounted() {
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == 'true') {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
    this.get_categories();
  }, watch: {},
  methods: {
    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    editDetails(item) {
      this.name = item.title;
      this.summary = item.summary;
      this.type = item.type;
      this.status_form = item.id;
if(item.type==1){
  this.price = item.values[0].price
}
    },
    get_categories() {
      var self = this;
      var formData = new FormData();
      axios.post('/api/admin/product/get_additional_options', formData, {}).then(function (response) {

        var content_cats = response.data;

        self.items = content_cats.tags.map((item, row_id) => {
          return {...item, row_id}
        });

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    goSubCategories(item) {
      this.$router.push({path: '/dashboard/products/additional-options-values/' + item.id});
    },
    login() {


      let self = this;
      const formData = new FormData()
      let url;
      if (this.status_form == 0) {
        url = "/api/admin/product/add_additional_option";
      } else {
        url = "/api/admin/product/update_additional_option";
        formData.append('id', this.status_form)

      }

      formData.append('name', this.name);
      formData.append('type', this.type);
      formData.append('summary', this.summary);
      formData.append('price', this.price);



      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;
        self.name = '';
        self.get_categories();

      })

          .catch(function (error) {

            console.log(error);
          });

    },
    delete_dialog(item) {
      this.$root.modal_component.show_confirm_modal('اخطار', "آیا مایل به حذف این ردیف هستید؟", ['تایید'], this.confirm_delete_name);
      this.status_form = item.id;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "/api/admin/product/delete_additional_option";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;
        self.get_categories();

      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },


  }
}


</script>
